import { I18nKey } from "@/libs/shared";
import { AvailableTasksSingleTaskRead, GetTask, GetTaskRead, SelfAssessmentRatingEnum, UserRead } from "@/services/api";

export const TaskStatus = {
  UNASSIGNED: 1,
  PENDING_DATA: 2,
  DECLINED: 3,
  IN_REVIEW: 4,
  REVIEWED: 5,
};
export const TaskStatusLabeled = {
  UNASSIGNED: "Unassigned", // must stay in english until backend returns it in the user's language
  PENDING_DATA: "In draft",
  DECLINED: "Declined",
  IN_REVIEW: "In review",
  REVIEWED: "Reviewed",
};

export const getTaskStatusTranslationKey = (status: number): I18nKey | undefined => {
  if (status === TaskStatus.UNASSIGNED) {
    return "assessments.status.unassigned";
  }

  if (status === TaskStatus.PENDING_DATA) {
    return "assessments.status.in_draft";
  }

  if (status === TaskStatus.DECLINED) {
    return "assessments.status.declined";
  }

  if (status === TaskStatus.IN_REVIEW) {
    return "assessments.status.in_review";
  }

  if (status === TaskStatus.REVIEWED) {
    return "assessments.status.reviewed";
  }
};

export const ConformityLevelTranslationLookup: { [key in SelfAssessmentRatingEnum]: I18nKey } = {
  99: "assessments.self_assessment_rating.not_applicable",
  2: "assessments.self_assessment_rating.does_not_meat",
  3: "assessments.self_assessment_rating.partially_meets",
  4: "assessments.self_assessment_rating.substantially_meets",
  5: "assessments.self_assessment_rating.fully_meets",
};

export const taskIsEditable = (task: AvailableTasksSingleTaskRead | GetTask) =>
  [
    TaskStatus.PENDING_DATA,
    TaskStatus.DECLINED,
    // Sometimes api returns status code, sometimes label. We must handle both cases.
    TaskStatusLabeled.PENDING_DATA,
    TaskStatusLabeled.DECLINED,
  ].includes(task.status!) && !task.is_deleted;
export const taskIsReviewable = (task: AvailableTasksSingleTaskRead | GetTask) =>
  // Sometimes api returns status code, sometimes label. We must handle both cases.
  [TaskStatusLabeled.IN_REVIEW, TaskStatus.IN_REVIEW].includes(task.status!) && !task.is_deleted;

export const taskIsReviewableByUser = (task: AvailableTasksSingleTaskRead | GetTaskRead, userId: string) =>
  taskIsReviewable(task) &&
  task.reviewers.some(
    (reviewer: UserRead | string) =>
      (typeof reviewer !== "string" && reviewer?.id === userId) || reviewer?.toString() === userId,
  );
